var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero"},[_c('figure',{staticClass:"hero__figure",attrs:{"data-parallax":"-0.3"}},[_c('img',{attrs:{"src":_vm.switchImg,"alt":_vm.hero.alt}})]),_vm._v(" "),_c('div',{staticClass:"hero__wrapper"},[_c('h2',{staticClass:"hero__title"},[_vm._v("\n      "+_vm._s(_vm.hero.title)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25f22874","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hero.vue
// module id = 552
// module chunks = 3